import { VariantStatus } from '../enums/VariantStatus.enum';
import { Preorder } from '../models/Preorder.model';
import { ViewVariant } from '../models/ShopifyVariant.model';
import { ViewProduct } from '../models/ViewProduct.model';
import { variantStatus } from '../util';
import { useSharedGetPreorderState } from './actions/usePreorderState';

export type VariantAvailability = Pick<ViewVariant, 'id' | 'sku' | 'color' | 'size' | 'fit'> & { status: VariantStatus };

export const useProductAvailability = (product: ViewProduct): VariantAvailability[] => {
  const preorders = useSharedGetPreorderState();
  const findPreorder = (v?: ViewVariant): Preorder =>
    (preorders || []).find((p: Preorder) => p.sku.toLowerCase() === (v?.sku || '').toLowerCase()) || ({} as Preorder);

  const variantAvailability = product.variants.map((v) => {
    const preorder = findPreorder(v);
    const status = variantStatus(preorder, v);

    return { id: v.id, sku: v.sku, color: v.color, size: v.size, fit: v.fit, status };
  });

  return variantAvailability;
};

export const useVariantAvailability = (variant: ViewVariant): VariantAvailability => {
  const preorders = useSharedGetPreorderState();
  const preorder = (preorders || []).find((p: Preorder) => p.sku.toLowerCase() === (variant.sku || '').toLowerCase()) || ({} as Preorder);
  const status = variantStatus(preorder, variant);
  return { id: variant.id, sku: variant.sku, color: variant.color, size: variant.size, fit: variant.fit, status };
};
